// Actions/authAction.js

import * as actionTypes from "../actionTypes";

export const adminLogin = (payload) => ({
    type: actionTypes.ADMIN_LOGIN,
    payload,
});
